import { render } from "./index.vue?vue&type=template&id=db2fcc48"
const script = {}

import exportComponent from "/root/workspace/want-ceo-backstage-management/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__